import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs';
import { ComponentBase } from 'src/app/core/base/common-base';

@Component({
  selector: 'app-lang-dropdwon',
  templateUrl: './lang-dropdwon.component.html',
  styleUrl: './lang-dropdwon.component.scss',
  standalone: true,
  imports: [CommonModule, TranslateModule, NgbModule],
})
export class LangDropdwonComponent extends ComponentBase {
  public constructor(public readonly translateService: TranslateService) {
    super();
  }

  public changeLanguage(language: string): void {
    this.translateService.use(language);

    this.translateService.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.reload();
      });
  }

  public reload(): void {
    window.location.reload();
  }
}
